import { setToken, removeToken } from "@/utils/auth";

const state = {
    token: null,
};

const mutations = {
    SET_TOKEN(state, token) {
        state.token = token;
    },
};

const actions = {
    login({ commit }, { token }) {
        commit("SET_TOKEN", token);
        setToken(token);
    },
    logout({ commit }) {
        commit("SET_TOKEN", null);
        removeToken();
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
};
